import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { APP_VERSION } from 'src/app/shared/config/app.constant';

@Injectable({
    providedIn: 'root'
})
export class UserAgentService {

    ua = '';

    constructor(private platform: Platform) { }

    async getUA() {
        this.ua = await this.buildUserAgent();
        return this.ua;
    }

    async buildUserAgent(): Promise<string> {

        let appVersion = '';

        try {
            const appInfo = await App.getInfo();
            appVersion = appInfo.version;
        } catch {
            appVersion = APP_VERSION;
        }

        const height = Math.max(window.screen.height, window.screen.width);
        const width = Math.min(window.screen.height, window.screen.width);

        const deviceInfo = await this.getDeviceInfo();

        return `Connexio App/v${appVersion} <${deviceInfo}> {h${height}w${width}}`;
    }

    private async getDeviceInfo(): Promise<string> {

        if (this.platform.is('android') || this.platform.is('ios')) {

            const info = await Device.getInfo();

            const osName = info.operatingSystem === 'ios' ? 'iOS' : 'Android';
            const osVersion = info.osVersion;
            const model = info.model || info.name || 'Device';

            return `${osName} ${osVersion}; ${model}`;
        }

        const browser = this.getBrowserInfo(navigator.userAgent);
        return `Web; ${browser}`;
    }

    private getBrowserInfo(ua: string): string {

        let browser = 'Browser';
        let version = '';

        if (/Chrome/.test(ua) && !/Edg/.test(ua)) {
            browser = 'Chrome';
            version = ua.match(/Chrome\/([\d.]+)/)?.[1] || '';
        }
        else if (/Firefox/.test(ua)) {
            browser = 'Firefox';
            version = ua.match(/Firefox\/([\d.]+)/)?.[1] || '';
        }
        else if (/Edg/.test(ua)) {
            browser = 'Edge';
            version = ua.match(/Edg\/([\d.]+)/)?.[1] || '';
        }
        else if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
            browser = 'Safari';
            version = ua.match(/Version\/([\d.]+)/)?.[1] || '';
        }

        const shortVersion = version ? version.split('.')[0] : '';

        return `${browser} ${shortVersion}`;
    }
}